module.exports = __webpack_public_path__ + "static/media/logo.7528d5b5.png";